module.exports = "<ng-content></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/angular4-files-upload/src/app/ng4-files/components/ng4-files-drop/ng4-files-drop.component.html
// module id = ../../../../angular4-files-upload/src/app/ng4-files/components/ng4-files-drop/ng4-files-drop.component.html
// module chunks = common